<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>User Field</mat-label>
    <mat-select id="user-field" formControlName="userField">
      @for (option of dateUserFieldNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="form-container">
    <mat-form-field appearance="outline" class="form-date-start">
      <mat-label i18n>From</mat-label>
      <input matInput [matDatepicker]="start" id="start" formControlName="start">
      <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
      <mat-datepicker #start></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-date-end">
      <mat-label i18n>To</mat-label>
      <input matInput [matDatepicker]="end" id="end" formControlName="end">
      <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
      <mat-datepicker #end></mat-datepicker>
    </mat-form-field>
  </div>
</ng-container>
